import axios from "axios";
import { DataGrid, Popup } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Paging,
  Scrolling,
  SearchPanel,
  Sorting,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";

export default function SiteList(props) {
  const { siteListPopupVisible, setSiteListPopupVisible } = props;

  const [dataSource, setDataSource] = useState(null);

  useEffect(async () => {
    async function fetchData() {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/site`
      );

      setDataSource(result.data);
    }

    fetchData();
  }, []);

  const onHiding = () => {
    setSiteListPopupVisible(false);
  };

  return (
    <Popup
      visible={siteListPopupVisible}
      dragEnabled={false}
      hideOnOutsideClick={false}
      showCloseButton={true}
      showTitle={true}
      title="Site List"
      height={"auto"}
      onHiding={onHiding}
    >
      <DataGrid
        dataSource={dataSource}
        keyExpr={"ykiho"}
        showBorders={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
        columnAutoWidth={true}
        wordWrapEnabled={true}
      >
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <LoadPanel enabled={true} />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />

        <Column dataField={"ykiho"} caption={"ykiho"} />
        <Column
          dataField={"yadmNm"}
          caption={"Site Name"}
          sortIndex={0}
          defaultSortOrder={"asc"}
        />
        <Column dataField={"addr"} caption="Address" />
      </DataGrid>
    </Popup>
  );
}
